import { Controller } from '@hotwired/stimulus'
import { useTargetMutation } from 'stimulus-use'

export default class extends Controller {
  static values = { mode: { type: String, default: 'duo'}, shiftCover: { type: Boolean, default: false } }
  static targets = ['triggerDuo', 'triggerTriple', 'card2', 'card3', 'from', 'to']

  connect() {
    useTargetMutation(this, { targets: ['from'] })
  }
  
  changeMode(event) {
    event.preventDefault()

    const mode = event.params.mode
    this.modeValue = mode
  }

  modeValueChanged() {
    const card3Inputs = this.card3Target.querySelectorAll('input')

    card3Inputs.forEach((el) => {
      if(this.modeValue == 'triple') {
        el.removeAttribute('disabled')
      } else {
        el.setAttribute('disabled', 'disabled')
      }
    })

    if(this.modeValue == 'triple') {
      this.element.classList.remove('two-way-wrapper')
      this.element.classList.add('three-way-wrapper')

      this.triggerDuoTarget.classList.remove('d-none')
      this.triggerTripleTarget.classList.add('d-none')
      this.card3Target.classList.remove('d-none')

      const fromTarget2 = this.getFromTarget(2)
      const toTarget3 = this.getToTarget(3)
      toTarget3.textContent = fromTarget2.textContent

      const fromTarget3 = this.getFromTarget(3)
      const toTarget1 = this.getToTarget(1)
      toTarget1.textContent = fromTarget3.textContent

    } else {
      this.element.classList.remove('three-way-wrapper')
      this.element.classList.add('two-way-wrapper')

      this.triggerDuoTarget.classList.add('d-none')
      if(!this.shiftCoverValue) {
        this.triggerTripleTarget.classList.remove('d-none')
      }
      this.card3Target.classList.add('d-none')

      const fromTarget1 = this.getFromTarget(1)
      const toTarget2 = this.getToTarget(2)
      toTarget2.textContent = fromTarget1.textContent
      const toTarget3 = this.getToTarget(3)
      toTarget3.textContent = ''

      const fromTarget2 = this.getFromTarget(2)
      const toTarget1 = this.getToTarget(1)
      toTarget1.textContent = fromTarget2.textContent
    }
  }

  // update To: sections on cards
  fromTargetChanged(element) {
    let shift_index = element.getAttribute('data-shift-index')
    let to_shift_index = null

    if(this.modeValue == 'duo') {
      if(shift_index == 1) {
        to_shift_index = 2
      } else if(shift_index == 2) {
        to_shift_index = 1
      }
    } else {
      if(shift_index == 1) {
        to_shift_index = 2
      } else if(shift_index == 2) {
        to_shift_index = 3
      } else if(shift_index == 3) {
        to_shift_index = 1
      }
    }

    const to_target = this.getToTarget(to_shift_index)

    to_target.textContent = element.textContent
  }

  shiftCoverChangedCallback(event) {
    this.shiftCoverValue = event.detail.value
  }

  shiftCoverValueChanged() {
    if(this.modeValue == 'triple') {
      this.modeValue = 'duo'
    }

    if(this.shiftCoverValue) {
      this.triggerTripleTarget.classList.add('d-none')
      this.triggerDuoTarget.classList.add('d-none')
    } else {
      this.triggerTripleTarget.classList.remove('d-none')
    }
  }

  getToTarget(shift_index) {
    return this.toTargets.find((el) => el.getAttribute('data-shift-index') == shift_index)
  }

  getFromTarget(shift_index) {
    return this.fromTargets.find((el) => el.getAttribute('data-shift-index') == shift_index)
  }
}
